import { cleanObject } from '@/helpers'

export const getExpirationDates = (state) => state.expirationDates

export const visualize = state => {
  let {
    paymentType,
    iban,
    beneficiaryName,
    beneficiaryAddress
  } = state
  return {
    paymentType,
    iban,
    beneficiaryName,
    beneficiaryAddress,
    expirationDates: state.expirationDates.list
                      .map(d => state.expirationDates._[d])
                      .sort((a, b) => new Date(b.date - new Date(a.date)))
  }
}

export const apificate = (state, getters) => {
  let _state = cleanObject(state)
  let payment = {}
  if (_state.paymentType) payment.paymentType = _state.paymentType
  if (_state.iban) payment.iban = _state.iban
  if (_state.beneficiaryName) payment.beneficiaryName = _state.beneficiaryName
  if (_state.beneficiaryAddress) payment.beneficiaryAddress = _state.beneficiaryAddress
  if (_state.expirationDates && _state.expirationDates.list.length > 0) payment.expirationDates = getters['expirationDates/apificate']
  return payment
}
